import { carcass } from "./carcass";
import { plano } from "./plano";

export const planonext = {
    namespaced: true,
    modules: {
        carcass,
        plano
    }
};



// WEBPACK FOOTER //
// ./src/store/planonext/planonext.js